import React from "react";
import { SquareCheckoutForm } from "~/components/SquareCheckoutForm";
import { ReactController } from "../react_controller";

export class SquareCheckoutFormController extends ReactController {
  connect() {
    this.root.render(<SquareCheckoutForm {...this.propsValue} />);
  }
}
